<template>
  <div id="lineSetting">
    <div class="lineContent">
      <!-- 左侧表单 -->
      <div class="left">
        <el-form
          :model="form"
          :rules="rules"
          ref="line"
          label-width="80px"
          label-position="left"
        >
          <div>
            <el-form-item label="机构名称" prop="organizationId">
              <el-select
                v-model="form.organizationId"
                :disabled="id ? true : false"
                clearable
                filterable
                @change="organizationChange"
              >
                <!-- v-if="mixinUserInfo && mixinUserInfo.organizationType === 1" -->
                <el-option
                  v-for="(item, index) in organizations"
                  :key="index"
                  :value="item.id"
                  :label="item.name"
                >
                </el-option>
              </el-select>
              <!-- <span v-else>{{
                organizations && organizations[0] && organizations[0].name
              }}</span> -->
            </el-form-item>
            <el-form-item label="日间价格" prop="daytimeFee">
              <el-input
                :value="form.daytimeFee"
                :maxlength="4"
                @input="handleInput($event, 'daytimeFee')"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>
            <el-form-item label="夜间价格" prop="nighttimeFee">
              <el-input
                :value="form.nighttimeFee"
                :maxlength="4"
                @input="handleInput($event, 'nighttimeFee')"
              >
                <template slot="append">元</template>
              </el-input>
            </el-form-item>

            <el-form-item>
              <span slot="label">
                <span style="display: inline-block; width: 1rem"></span>
                <span>线路标签</span>
              </span>
              <el-input v-model="form.labelName" disabled></el-input>
            </el-form-item>
          </div>
          <div id="start" class="start">
            <h2>设置出发地</h2>
            <div class="section-tip">
              <i class="el-icon-info"></i>
              出发地围栏来自《应等站点》预设，如需修改围栏请
              <el-button type="text" size="mini" @click="goStationManage">去站点管理 &rsaquo;</el-button>
            </div>
            <div class="places">
              <div
                class="places-item"
                :class="{
                  focus: active.place == 0,
                }"
                @click="clickStart"
              >
                <div class="places-item-left">
                  <div class="radios">
                    <el-radio :value="2" :label="2" border>围栏站点</el-radio>
                  </div>
                  <el-form-item prop="airportStationId">
                    <el-select
                      v-model="form.airportStationId"
                      placeholder="请选择发车点"
                      clearable
                      @change="stationStartChange"
                      @focus="stationStartClick"
                    >
                      <el-option
                        v-for="item in stationStartList"
                        :key="item.id"
                        :label="item.stationName"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <div v-if="stationStartInfo && stationStartInfo.id" class="fence-status">
                    <i class="el-icon-location-outline" style="color:#0289ff"></i>
                    已选围栏：{{ stationStartInfo.stationName }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="end">
            <h2>设置目的地</h2>

            <div class="places">
              <div
                :class="{
                  focus: active.place == 1,
                }"
                class="places-item"
                @click="clickEnd"
              >
                <div class="places-item-left">
                  <div class="radios">
                    <el-radio :value="2" :label="2" border>围栏站点</el-radio>
                  </div>
                  <div>
                    <el-form-item prop="endStationName">
                      <el-input
                        v-model="form.endStationName"
                        placeholder="设置围栏名称，例如高新区接送、大学城区域"
                        maxlength="20"
                      >
                      </el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>
            </div>

            <div class="buttons">
              <el-button
                style="width: 100%; padding: 10px 0; margin-bottom: 6px"
                :loading="loading"
                @click="getHistoryPolygons()"
                >选择历史围栏</el-button
              >
              <div v-if="stationEndInfo && stationEndInfo.enclosureAddress" class="fence-status" style="margin-top:4px">
                <i class="el-icon-check" style="color:#67c23a"></i>
                已设置围栏：{{ form.endStationName || '未命名' }}
                <el-button type="text" size="mini" style="color:#F56C6C;margin-left:6px" @click="emptyPolygon">清空</el-button>
              </div>
              <div v-else class="fence-status fence-status--warn">
                <i class="el-icon-warning-outline" style="color:#E6A23C"></i>
                请在右侧地图上手绘目的地围栏，或点击“选择历史围栏”
              </div>
            </div>
          </div>

          <div class="flex">
            <el-button style="width: 100%" @click="goBack"> 取消 </el-button>
            <el-button type="primary" style="width: 100%" @click="goStep">
              完成
            </el-button>
          </div>
        </el-form>
      </div>
      <!-- 右侧地图 -->
      <div class="right">
        <div class="buttons mapButtons">
          <div>
            <choose-address
              :value.sync="paramsHistoryPolygons.searchText"
              placeholder="在地图上搜索位置"
              :citycode="cityAdcode"
              @clickRowFn="clickPoint"
              style="width: 200px"
            ></choose-address>
          </div>
          <div @click="recommendPolygon" :class="{active: active.place==1}">选择围栏</div>
          <div @click="startDraw" :class="{active: isDrawing}">手绘围栏</div>
          <div @click="emptyPolygon">清空围栏</div>
          <div @click="clickHollow" :class="{active: active.actionType==='hollow'}">挖空围栏</div>
        </div>
        <div id="mapCtx"></div>
      </div>
    </div>
    <!-- 历史围栏 -->
    <el-dialog
      title="选择历史围栏"
      class="history"
      width="520px"
      close-on-click-modal
      :visible.sync="historyPolygonVisible"
      @close="closeHistoryPolygon"
    >
      <p>保存过的围栏，将自动存入历史围栏</p>
      <div class="search">
        <el-input
          type="text"
          v-model="paramsHistoryPolygons.stationName"
          placeholder="搜索围栏名称"
        />
        <el-button type="primary" @click="searchHistoryPolygons()">搜索</el-button>
      </div>
      <el-table
        border
        max-height="500"
        ref="singleTable"
        :data="historyPolygons.content"
        style="width: 100%"
      >
        <el-table-column
          property="date"
          label="围栏名称"
          prop="stationName"
          width="300"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.stationName }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" property="date" label="操作">
          <template slot-scope="scope">
            <el-button
              @click.stop="handleChoose(scope.row)"
              type="text"
              size="small"
              >选择</el-button
            >
            <el-button
              @click="handleDelete(scope.row, scope.$index)"
              type="text"
              size="small"
              style="color: red"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="paramsHistoryPolygons.page || 1"
        :page-size="paramsHistoryPolygons.size"
        :total="historyPolygons.total"
        :page-sizes="[20, 30, 40, 60]"
        @size-change="sizeChangeFn"
        @current-change="currentChangeFn"
        layout="total, prev, pager, next"
        :disabled="loading"
      />
    </el-dialog>
    <!-- 围栏选择弹窗（行政区 / POI地点 / 手绘说明） -->
    <el-dialog
      class="history fence-dialog"
      title="选择目的地围栏"
      :visible.sync="polygonVisible"
      width="620px"
      close-on-click-modal
      @close="closeFenceDialog"
    >
      <el-tabs v-model="fenceTab" type="border-card">
        <!-- Tab1: 行政区围栏 -->
        <el-tab-pane label="🌏 行政区围栏" name="district">
          <p style="color:#909399;font-size:12px;margin-bottom:12px">选择城市或区/县，自动使用行政边界生成围栏</p>
          <div class="search" style="margin-bottom:12px">
            <el-select
              v-model="polygonParams.cityCode"
              placeholder="选择城市"
              style="width:200px;margin-right:10px"
              filterable
              @change="changeCity"
            >
              <el-option
                v-for="(item, index) in cityList"
                :key="index"
                :label="item.name"
                :value="item.citycode"
              ></el-option>
            </el-select>
          </div>
          <el-table border max-height="400" :data="polygonTableData" style="width: 100%">
            <el-table-column property="name" label="围栏名称" width="300">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
                <el-tag style="margin-left: 5px" type="info">
                  {{ scope.row.level === 'city' ? '城市' : '区县' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="chooseCity(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Tab2: POI地点围栏 -->
        <el-tab-pane label="📍 POI地点围栏" name="poi">
          <p style="color:#909399;font-size:12px;margin-bottom:12px">搜索火车站、机场、景区、学校、医院等地点，使用其周边区域生成围栏</p>
          <div class="search" style="margin-bottom:12px;display:flex;gap:8px">
            <el-select v-model="poiSearchType" placeholder="地点类型" style="width:130px" @change="onPoiTypeChange">
              <el-option v-for="t in poiTypes" :key="t.value" :label="t.label" :value="t.value"></el-option>
            </el-select>
            <el-input v-model="poiSearchKeyword" placeholder="输入地点名称搜索" style="flex:1" @keyup.enter.native="searchPoi"></el-input>
            <el-button type="primary" :loading="poiLoading" @click="searchPoi">搜索</el-button>
          </div>
          <div v-if="poiResults.length === 0 && !poiLoading" style="color:#909399;font-size:13px;text-align:center;padding:30px 0">
            <span v-if="poiSearchKeyword">未找到相关地点，请尝试其他关键词</span>
            <span v-else>请输入地点名称进行搜索</span>
          </div>
          <el-table v-if="poiResults.length > 0" border max-height="400" :data="poiResults" style="width:100%">
            <el-table-column label="地点名称" prop="name" width="200">
              <template slot-scope="scope">
                <div>{{ scope.row.name }}</div>
                <div style="color:#909399;font-size:11px">{{ scope.row.address }}</div>
              </template>
            </el-table-column>
            <el-table-column label="类型" prop="typeName" width="120"></el-table-column>
            <el-table-column align="center" label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="choosePoiFence(scope.row)">选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <!-- Tab3: 手绘围栏 -->
        <el-tab-pane label="✏️ 手绘围栏" name="draw">
          <div style="padding:20px 0;line-height:2;color:#606266;font-size:13px">
            <p><strong>手绘围栏操作步骤：</strong></p>
            <p>1️⃣ 关闭此对话框</p>
            <p>2️⃣ 点击地图工具栏中的《手绘围栏》按钮</p>
            <p>3️⃣ 在地图上按住鼠标左键拖拽绘制围栏</p>
            <p>4️⃣ 释放鼠标后围栏自动完成</p>
            <p style="color:#E6A23C">⚠️ 围栏线条禁止相交，否则无效</p>
          </div>
          <div slot="footer" style="text-align:right;margin-top:10px">
            <el-button type="primary" @click="startDrawFromDialog">开始手绘</el-button>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import AMap from "AMap";
import polygonClipping from "polygon-clipping";
import isPolygonsOverlap from "@/assets/js/polygon";
import { getCityList, getCity } from "@/assets/js/amapData";
export default {
  name: "lineSetting",
  data() {
    return {
      id: this.$route.query.id,
      // 起始地点集合
      form: {
        organizationId: null, // 机构名称
        labelName: "场站", // 线路标签
        daytimeFee: null,
        nighttimeFee: null,
        airportStationId: "",
        endStationName: "",
      },
      stationStartList: [],
      stationStartInfo: {},
      stationEndInfo: {},
      rules: {
        daytimeFee: [{ required: true, message: "请设置日间价格" }],
        nighttimeFee: [{ required: true, message: "请设置夜间价格" }],
        organizationId: [{ required: true, message: "请选择机构名称" }],
        airportStationId: [{ required: true, message: `请选择发车点` }],
        endStationName: [{ required: true, message: `请设置目的地` }],
      },

      // 当前操作的 地址类型：0起点 1终点、地址下标、地图绘制类型
      active: {
        place: 0,
        actionType: "draw", // 站点site ||  绘制draw || 挖空hollow
      },
      // 地图上下文
      mapCtx: null,
      // 鼠标工具
      mouseTool: null,
      polygonColor: {
        startBKGD: "#deefff",
        startBKGDFC: "#0288FF",
        startBDFC: "#68b6ff",
        endBKGD: "#deffe7",
        endBKGDFC: "#40ff02",
        endBDFC: "#228b2236",
      },
      // 地图当前城市,用于搜索
      cityAdcode: null,
      // 历史围栏
      historyPolygonVisible: false,
      paramsHistoryPolygons: {
        page: 1,
        size: 10,
        searchText: null,
        stationName: null,
        stationType: null,
      },
      historyPolygons: [],

      polygonVisible: false,
      cityList: [],
      polygonTableData: [],
      polygonParams: {
        cityCode: "028",
      },
      loading: false,
      // POI 围栏搜索
      fenceTab: 'district',
      poiSearchType: '',
      poiSearchKeyword: '',
      poiLoading: false,
      poiResults: [],
      isDrawing: false,
      poiTypes: [
        { label: '火车站', value: '150200' },
        { label: '机场', value: '150101' },
        { label: '地铁站', value: '150500' },
        { label: '公车站', value: '150700' },
        { label: '景区', value: '110200' },
        { label: '学校', value: '141200' },
        { label: '医院', value: '090100' },
        { label: '购物中心', value: '060100' },
        { label: '公园广场', value: '110101' },
        { label: '全部类型', value: '' },
      ],
    };
  },
  computed: {
    // 当前操作的目标地址对象
    targetPlace() {
      return this.active.place == 0
        ? this.stationStartInfo
        : this.stationEndInfo;
    },
  },
  watch: {},
  created() {
    this.cityList = getCityList();
  },
  async mounted() {
    this.initMap();
    await this.mixinOrganizations();
    if (
      !this.id &&
      this.mixinUserInfo &&
      this.mixinUserInfo.organizationType === 2
    ) {
      if (
        this.organizations &&
        this.organizations[0] &&
        this.organizations[0].id
      ) {
        this.$set(this.form, "organizationId", this.organizations[0].id);
        this.getStationStartList(this.organizations[0].id)
      }
    }
  },
  methods: {
    async organizationChange(value) {
      this.form.airportStationId = "";
      this.form.startStationName = null;
      this.form.startEnclosureAddress = null;
      this.form.startCityCode = null;
      this.form.startAdCode = null;
      this.stationStartList = [];
      await this.getStationStartList(value);
      if(this.stationStartInfo.polygon) {
        this.mapCtx.remove(this.stationStartInfo.polygon);
        this.stationStartInfo.polygon = null;
      }
    },
    closeHistoryPolygon() {
      this.paramsHistoryPolygons.stationName = "";
      this.paramsHistoryPolygons.searchText = "";
    },
    /* 跳转到发车点（应等站点）管理页，修改出发地围栏 */
    goStationManage() {
      this.$router.push({ path: '/airportStart' })
    },
    stationStartClick() {
      if (!this.form.organizationId) {
        this.$message.warning("请先选择机构名称");
      }
    },
    // 选择出发地
    stationStartChange(value) {
      this.active = {
        place: 0,
        actionType: "draw",
      };
      if (!value) {
        return;
      }
      // 清除上一个围栏
      if (this.targetPlace.polygon) {
        this.mapCtx.remove(this.targetPlace.polygon);
        this.targetPlace.polygon = null;
      }
      let item = this.stationStartList.find((item) => item.id == value);
      this.form.airportStationId = item.id;
      this.form.startStationName = item.stationName;
      this.form.startEnclosureAddress = item.enclosureAddress;
      this.form.startCityCode = item.cityCode;
      this.form.startAdCode = item.adCode;
      this.stationStartInfo = { ...item };
      this.handleDraw(
        JSON.parse(this.stationStartInfo.enclosureAddress),
        "get",
        false
      );
    },

    // 获取发车点
    async getStationStartList(organizationId) {
      if (!organizationId) {
        this.$message.warning("请选择机构名称");
        return;
      }
      const url = "/api/v1/manage/airport/stationRail";
      const { code, data } = await this.$axios.get(url, {
        organizationId: organizationId,
      });
      if (code == 1) {
        this.stationStartList = data;
      }
    },
    /* 初始化地图 */
    initMap() {
      this.mapCtx = new AMap.Map("mapCtx", {
        mapStyle: "amap://styles/572516903e2f1273ed9c97f54ebacd89",
        resizeEnable: true,
        zoom: 15,
        doubleClickZoom: false,
        center: new AMap.LngLat(104.065861, 30.657401),
      });

      // 渲染完地图再请求数据
      this.getInfo();

      this.cityAdcode = this.mapCtx.getAdcode();

      // 初始化鼠标工具
      this.mouseTool = new AMap.MouseTool(this.mapCtx);

      // 鼠标绘制完毕事件
      this.mouseTool.on("draw", (e) => {
        this.mouseTool.close(true);
        this.isDrawing = false;

        // obj对象为绘制出来的覆盖物对象。
        this.mapCtx.remove(e.obj);
        if (this.active.place == 0) {
          return;
        }
        // 绘制结果为多边形时
        if (e.obj.CLASS_NAME === "AMap.Polygon") {
          let corners = Array.from(e.obj.getPath(), (value) => [
            value.lng,
            value.lat,
          ]);

          this.handleDraw(corners, "custom", true);
        }
      });
      this.placeChange();
    },

    /* 聚焦目标地址变化，覆盖物重新渲染 */
    placeChange() {
      if (this.active.place == 0) {
        // 若当前操作的是起点地址
        if (this.stationStartInfo.polygon) {
          this.stationStartInfo.polygon.setOptions({
            fillOpacity: 0.3,
            fillColor: this.polygonColor.startBKGDFC,
            strokeColor: this.polygonColor.startBDFC,
          });
          this.mapCtx.setFitView(
            this.stationStartInfo.polygon,
            true,
            [200, 200, 200, 200],
            16
          );
        }
      } else if (this.active.place == 1) {
        if (this.stationEndInfo.polygon) {
          this.stationEndInfo.polygon.setOptions({
            fillOpacity: 0.3,
            fillColor: this.polygonColor.endBKGDFC,
            strokeColor: this.polygonColor.endBDFC,
          });
          this.mapCtx.setFitView(
            this.stationEndInfo.polygon,
            true,
            [200, 200, 200, 200],
            16
          );
        }
      }

      if (!this.targetPlace?.polygon) {
        this.actionTypeChange(2);
      }
    },

    /**
     * 绘制类型变化
     * @actionType 点击地址上单选框的回调参数
     * @place      0 起点  1 终点
     * @item       地址    可选
     * @index      下标    可选
     */
    actionTypeChange(actionType, place, item) {
      if (item) {
        this.active = {
          place: place || this.active.place,
          actionType: new Map([
            [2, "draw"],
            [3, "hollow"],
          ]).get(actionType),
        };
      } else if (actionType) {
        console.log(this.active.place,233232);
        this.active = {
          place: place || this.active.place,
          actionType: new Map([
            [2, "draw"],
            [3, "hollow"],
          ]).get(actionType),
        };
      }

      if (this.active.actionType == "draw") {
        // 若目标地址绘制类型为围栏(多边形)
        if (!this.targetPlace.polygon) {
          // 且不存在围栏
          if (this.active.place == 0) {
            this.mouseTool.polygon({
              fillOpacity: 0.3,
              fillColor: this.polygonColor.startBKGDFC,
              strokeColor: this.polygonColor.startBDFC,
            });
          } else {
            this.mouseTool.polygon({
              fillOpacity: 0.3,
              fillColor: this.polygonColor.endBKGDFC,
              strokeColor: this.polygonColor.endBDFC,
            });
          }
        }
      } else if (this.active.actionType == "hollow") {
        // 若目标地址绘制类型为挖空(多边形)
        this.mouseTool.polygon({
          fillColor: "gainsboro",
          strokeColor: "#fffffff0",
        });
      }
    },

    /* 地图搜索-选择地点 */
    async clickPoint(res) {
      if (this.active.place == 1) {
        this.mapCtx.panTo(res.location);
        this.mapCtx.setZoom(15);
      }
    },

    /**
     * 处理绘制的多边形
     * @corners   多边形原始角数据
     */
    handleDraw(corners, key, isRegeo) {
      // 判断这个围栏是否规范,长度大于1说明生成了一个以上的围栏,同时difference函数会补全封闭角,千万别动这行
      let data = null;
      if (key == "custom") {
        data = polygonClipping.difference([corners]);
        if (data.length > 1) {
          this.$message.warning("围栏线条禁止相交，请重新绘制");
          this.actionTypeChange(2);
          return;
        }
      } else {
        data = corners;
      }

      if (this.active.actionType === "draw") {
        this.formAddPolygon(data);
        isRegeo && this.formAddCityData(data);
      } else if (this.active.actionType === "hollow") {
        // 原围栏角数据
        let base = this.targetPlace.polygon.getPath();

        // 合并已建设围栏(多边形)的角数据和挖空多边形的角数据，生成新的的角数据
        data = this.mergeHollow(base, data);

        // 设置新生成的围栏
        this.targetPlace.polygon.setPath(data);
      }

      this.placeChange();
    },

    /**
     * 处理绘制的多边形 => form添加围栏(多边形)
     * @corners   多边形原始角数据
     */
    formAddPolygon(corners) {
      // 生成并添加围栏
      this.targetPlace.polygon = this.structurePolygon(corners);
    },

    /**
     * 处理绘制的多边形 => form添加围栏(多边形)的城市信息数据
     * @corners   多边形原始角数据
     * @city      城市数据
     */
    async formAddCityData(corners, resCity = null) {
      if (corners.length > 0) {
        let arr = [];
        if (!Array.isArray(corners[0])) {
          arr = corners[0];
        } else {
          arr = corners[0][0][0];
        }

        let regeo = await this.$AMap.AMapReGeo(arr);
        resCity = regeo.regeocode.addressComponent;

        if (resCity) {
          console.log(55,233232,corners,resCity);
          this.setEndForm({
            ...resCity,
            stationName: this.form.endStationName|| "",
            enclosureAddress: corners.length > 0 ? JSON.stringify(corners) : "",
          });
        }
      }
    },
    setEndForm(row) {
      this.form.endStationName = row.stationName;
      this.form.endEnclosureAddress = row.enclosureAddress;
      this.form.endCityCode = row.citycode ||  row.cityCode;
      this.form.endAdCode = row.adcode ||  row.adCode;
    },

    /**
     * 挖空角数据处理
     * @base      已建设围栏的原始角数据
     * @hollow    挖空多边形的原始角数据
     */
    mergeHollow(base, hollow) {
      let res = null;
      if (
        base[0] &&
        Array.isArray(base[0]) &&
        base[0][0] &&
        Array.isArray(base[0][0]) &&
        base.length > 1
      ) {
        /* 被挖断的围栏处理 */
        let all = [];
        for (let i = 0; i < base.length; i++) {
          let allRes = this.baseData(base[i], []);
          if (isPolygonsOverlap(hollow, allRes)) {
            allRes.push(hollow[0][0]);
            res = polygonClipping.difference(allRes);
          }
          all = [...all, ...res];
        }
        this.formAddCityData(all);
        return all;
      } else {
        /* 一般围栏处理 */
        let allRes = this.baseData(base);
        allRes.push(hollow[0][0]);
        res = polygonClipping.difference(allRes);
        this.formAddCityData(res);
        return res;
      }
    },

    /* 复杂围栏处理,比如一个围栏被挖断 */
    baseData(data, list = []) {
      if (!Array.isArray(data[0])) {
        let lnglat = data.map((val) => [val.lng, val.lat]);
        list.push(lnglat);
      } else {
        for (let i = 0; i < data.length; i++) {
          this.baseData(data[i], list);
        }
      }
      return list;
    },

    /**
     * 原始角数据生成围栏(多边形)
     * @corners   多边形原始角数据
     */
    structurePolygon(corners) {
      let polygon = new AMap.Polygon({
        map: this.mapCtx,
        path: corners,
        fillOpacity: 0.5,
        strokeOpacity: 1,
        fillColor:
          this.active.place == 0
            ? this.polygonColor.startBKGD
            : this.polygonColor.endBKGD,
        strokeColor:
          this.active.place == 0
            ? this.polygonColor.startBDFC
            : this.polygonColor.endBDFC,
      });
      return polygon;
    },

    /* 点击起点 */
    clickStart() {
      this.active = {
        place: 0,
        actionType: "draw",
      };
      this.actionTypeChange(2, 0, this.stationStartInfo);
      this.placeChange();
    },
    /* 点击终点 */
    clickEnd() {
      setTimeout(() => {
        this.active = {
          place: 1,
          actionType: "draw",
        };
        this.actionTypeChange(2, 1, this.stationEndInfo);
        this.placeChange();
      }, 100);
    },

    handleInput(value, key) {
      this.form[key] = value.replace(/[^0-9]/g, "");
    },

    updateTableData(citycode) {
      this.polygonParams.cityCode = citycode;
      const tableData = getCity(citycode);
      const data = [
        {
          adcode: tableData.adcode,
          center: tableData.center,
          citycode: tableData.citycode,
          level: tableData.level,
          name: tableData.name,
        },
        ...tableData.districts,
      ];
      this.polygonTableData = data;
    },
    /* 推荐围栏数据 */
    async recommendPolygon() {
      if (!this.targetPlace?.stationType == 2) {
        this.$message.info("需选择围栏站点才可使用");
        return;
      }
      const lng = this.mapCtx.getCenter();
      let regeo = await this.$AMap.AMapReGeo(lng);
      if (regeo.info == "OK") {
        this.updateTableData(regeo.regeocode.addressComponent.citycode);
        this.polygonVisible = true;
      } else {
        console.log("regeo::: ", regeo);
        this.$message.error("获取经纬度失败");
        return;
      }
    },
    changeCity(value) {
      this.updateTableData(value);
    },
    chooseCity(row) {
      let that = this;
      if (this.targetPlace.polygon) {
        // 若之前目标地址已有围栏 > 则删除围栏数据
        this.mapCtx.remove(this.targetPlace.polygon);
        this.targetPlace.polygon = null;
      }

      var opts = {
        subdistrict: 0, //获取边界不需要返回下级行政区
        extensions: "all", //返回行政区边界坐标组等具体信息
        level: "district", //查询行政级别为 市
      };
      let district = new AMap.DistrictSearch(opts);
      district.setLevel(row.level);
      district.search(row.adcode, function (status, result) {
        console.log("result::: ", result);
        if (result.info === "OK") {
          [
            that.targetPlace.stationName,
            that.targetPlace.city,
            that.targetPlace.cityCode,
            that.targetPlace.adCode,
          ] = [row.name, row.name, row.cityCode, row.adCode];
          let bounds = result.districtList[0].boundaries;
          if (bounds) {
            //生成行政区划polygon
            for (let i = 0; i < bounds.length; i += 1) {
              bounds[i] = [bounds[i]];
            }
            that.active.actionType = "draw";
            that.polygonVisible = false;
            that.setEndForm({
              stationName: row.name,
              enclosureAddress: JSON.stringify(bounds),
              adcode: row.adcode,
              citycode: row.citycode,
            });
            that.handleDraw(bounds, "get", false);
          }
        } else {
          that.$message.error("获取区域围栏失败");
        }
      });
    },

    /* 清空围栏数据 */
    emptyPolygon() {
      if (!this.targetPlace?.polygon) {
        this.$message.info("该地点未设置围栏");
        return;
      }
      this.$confirm(`确定要清空该围栏？`, "提示").then(() => {
        this.mapCtx.remove(this.targetPlace.polygon);
        this.targetPlace.polygon = null;

        this.actionTypeChange(2);
      });
    },

    /* 点击挖空 */
    clickHollow() {
      if (this.targetPlace?.polygon) {
        this.actionTypeChange(3);
      } else {
        this.$message.info("该地址没有围栏");
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    /* 点击下一步 */
    async goStep() {
      this.$refs.line.validate(async (valid) => {
        if (valid) {
          // 验证名称
          let { code, data } = await this.$axios.get(
            "/api/v1/manage/line/check",
            {
              startStationName: this.form.startStationName,
              endStationName: this.form.endStationName,
              lineId: this.id || null,
            }
          );
          if (code == 1) {
            if (data) {
              this.$message("存在相同起点/终点城市名称，请重新输入");
              return;
            }
            // 验证所有地址存在覆盖物
            let everyList = [this.stationStartInfo, this.stationEndInfo];
            let hasNull = false;
            for (const item of everyList) {
              if (!item.polygon) {
                hasNull = true;
                break;
              }
            }
            if (hasNull) {
              this.$message.info("有地址未设置围栏，请检查");
              return;
            }
            this.save();
          }
        } else {
          this.$message.info("请先完善线路信息");
        }
      });
    },

    /* 点击保存 */
    save() {
      if (this.id) {
        this.putFn();
      } else {
        this.postFn();
      }
    },

    /* 接口请求-添加 */
    async postFn({ ...params } = JSON.parse(JSON.stringify(this.form))) {
      this.loading = true;
      let url = "/api/v1/manage/airport/line";

      let res = await this.$axios.post(url, params);
      if (res && res.code === 1) {
        this.$message.success("添加成功！");
        this.goBack();
      }
      this.loading = false;
    },

    /* 接口请求-编辑 */
    async putFn({ ...params } = JSON.parse(JSON.stringify(this.form))) {
      this.loading = true;
      let url = "/api/v1/manage/airport/line";

      let res = await this.$axios.put(url, params);
      if (res && res.code === 1) {
        this.$message.success("修改成功！");
        this.goBack();
      }
      this.loading = false;
    },

    /* 获取线路详情 */
    async getInfo() {
      if (!this.id) {
        return false;
      }
      let url = "/api/v1/manage/airport/line/" + this.id;
      let { code, data } = await this.$axios.get(url);
      if (code === 1) {
        await this.getStationStartList(data.organizationId);
        this.form = { ...data };
        this.getInfoOverlay();
      }
    },

    /* 获取详情后-覆盖物处理 */
    getInfoOverlay() {
      const list = [
        JSON.parse(this.form.startEnclosureAddress),
        JSON.parse(this.form.endEnclosureAddress),
      ];
      list.forEach((item, index) => {
        this.active = {
          place: index,
          actionType: "draw",
        };
        this.formAddPolygon(item, "get", false);

        this.mapCtx.setFitView();
        this.placeChange();
      });
    },

    /* 历史围栏页码改变的回调，返回改变后的页码 */
    sizeChangeFn(val) {
      this.paramsHistoryPolygons.size = val;
      this.getHistoryPolygons();
    },
    /* 切换每页条数时的回调，返回切换后的每页条数 */
    currentChangeFn(val) {
      this.paramsHistoryPolygons.page = val;
      this.getHistoryPolygons();
    },
    searchHistoryPolygons(){
      this.paramsHistoryPolygons.page = 1;
      this.getHistoryPolygons();
    },

    /* 获取历史围栏数据 */
    async getHistoryPolygons() {
      this.clickEnd();
      this.loading = true;
      let url = "/api/v1/manage/line/stationRail/history";
      let data = await this.$axios.get(url, this.paramsHistoryPolygons);
      if (data.data.length === 0) {
        this.$message.info(`无历史数据，请创建新围栏数据`);
        this.historyPolygons = {
          content: [],
          total: 0,
        };
      } else {
        this.historyPolygonVisible = true;
        if (data) {
          this.historyPolygons = {
            content: data.data,
            total: data.total,
          };
        }
      }
      this.loading = false;
    },

    /* 选择一个历史站点/围栏 */
    handleChoose(row) {
      console.log('row::: ', row);
      if (this.targetPlace.polygon) {
        this.mapCtx.remove(this.targetPlace.polygon);
        this.targetPlace.polygon = null;
      }

      this.setEndForm(row);
      this.handleDraw(JSON.parse(row.enclosureAddress), "get", false);
      this.historyPolygonVisible = false;
    },

    /* 关闭围栏选择弹窗，重置状态 */
    closeFenceDialog() {
      this.poiResults = [];
      this.poiSearchKeyword = '';
    },
    /* POI 类型切换时清空结果 */
    onPoiTypeChange() {
      this.poiResults = [];
      this.poiSearchKeyword = '';
    },
    /* 搜索 POI 地点（复用项目封装的 $AMap.AMapPlaceSearch） */
    async searchPoi() {
      if (!this.poiSearchKeyword) {
        this.$message.warning('请输入搜索关键词');
        return;
      }
      this.poiLoading = true;
      this.poiResults = [];
      try {
        const res = await this.$AMap.AMapPlaceSearch({
          keyword: this.poiSearchKeyword,
          type: this.poiSearchType || '',
          city: this.cityAdcode || '',
          extensions: 'all',
          citylimit: false,
        });
        if (res && res.code === 1 && res.data) {
          this.poiResults = res.data.map(p => ({
            id: p.id,
            name: p.name,
            address: typeof p.address === 'string' ? p.address : '',
            typeName: p.type || '',
            location: p.location,
            adcode: p.adcode,
            citycode: p.citycode,
          }));
        }
      } catch (e) {
        console.error('[POI搜索失败]', e);
      }
      this.poiLoading = false;
    },
    /* 选择 POI 地点，以其所在区县行政边界作为围栏 */
    choosePoiFence(poi) {
      if (!poi.adcode) {
        this.$message.warning('该地点无可用的行政区划信息，请尝试手绘围栏');
        return;
      }
      const opts = { subdistrict: 0, extensions: 'all', level: 'district' };
      const district = new AMap.DistrictSearch(opts);
      district.search(poi.adcode, (status, result) => {
        if (result.info === 'OK' && result.districtList && result.districtList[0]) {
          const districtItem = result.districtList[0];
          let bounds = districtItem.boundaries;
          if (!bounds || bounds.length === 0) {
            this.$message.warning('未获取到该地点的围栏数据，请尝试手绘围栏');
            return;
          }
          // 希望围栏覆盖 POI 中心点，选择最近的分割区域
          const center = poi.location;
          let bestBound = bounds[0];
          if (bounds.length > 1 && center) {
            let minDist = Infinity;
            bounds.forEach(b => {
              const pts = b.getPath ? b.getPath() : b;
              if (pts && pts.length > 0) {
                const p0 = pts[0];
                const d = Math.pow((p0.lng || p0[0]) - center.lng, 2) + Math.pow((p0.lat || p0[1]) - center.lat, 2);
                if (d < minDist) { minDist = d; bestBound = b; }
              }
            });
          }
          bounds = [bestBound];
          if (this.targetPlace.polygon) {
            this.mapCtx.remove(this.targetPlace.polygon);
            this.targetPlace.polygon = null;
          }
          this.active = { place: this.active.place, actionType: 'draw' };
          this.polygonVisible = false;
          this.setEndForm({
            stationName: poi.name,
            enclosureAddress: JSON.stringify(bounds),
            adcode: poi.adcode,
            citycode: poi.citycode || districtItem.citycode,
          });
          this.handleDraw(bounds, 'get', false);
          this.$message.success(`已选择《${poi.name}》所在区县围栏`);
        } else {
          this.$message.error('获取地点围栏失败，请尝试手绘围栏');
        }
      });
    },
    /* 手动启动手绘模式 */
    startDraw() {
      if (this.active.place === 0) {
        this.$message.warning('出发地围栏来自应等站点，请在左侧选择发车点后自动加载');
        return;
      }
      this.isDrawing = true;
      this.active = { place: 1, actionType: 'draw' };
      this.mouseTool.polygon({
        fillOpacity: 0.3,
        fillColor: this.polygonColor.endBKGDFC,
        strokeColor: this.polygonColor.endBDFC,
      });
      this.$message.info('手绘模式已开启，请在地图上拖拽绘制围栏轮廓');
    },
    /* 从弹窗内启动手绘 */
    startDrawFromDialog() {
      this.polygonVisible = false;
      this.$nextTick(() => this.startDraw());
    },
    /* 删除历史围栏 */
    handleDelete(row) {
      this.$confirm(`确认删除吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.loading = true;
        let url = "/api/v1/manage/line/stationRail/history/" + row.id;
        let data = await this.$axios.delete(url);
        if (data && data.code === 1) {
          this.$message.success("已删除");
          this.getHistoryPolygons();
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
#lineSetting {
  height: 100%;
  box-sizing: border-box;

  .lineContent {
    height: 100%;
    // height: calc(100% - 20px);
    display: flex;

    .left {
      box-sizing: border-box;
      width: 20%;
      // padding: 0rem 0rem;
      margin-right: 1%;
      box-shadow: 2px 2px 3px 0.5px #65656510;

      h2 {
        line-height: 1;
        text-indent: 1rem;
        border-left: 0.5rem solid #0289ff6c;
        margin-bottom: 2rem;
      }

      /deep/ .el-form {
        height: 100%;
        padding: 0 2rem 2rem 0.5rem;
        box-sizing: border-box;
        margin: 0;
        overflow-y: auto;
        overflow-x: hidden;

        &::-webkit-scrollbar {
          width: 3px !important;
          background-color: rgba(255, 0, 0, 0) !important;
        }
      }

      .start {
        margin-bottom: 4rem;
      }

      .end {
        margin-bottom: 4rem;

        h2 {
          border-color: #228b226c;
        }

        .places-item.focus {
          background-color: rgb(242, 255, 240);
          box-shadow: 0 0 0 2px #228b2252, 0 0 4px 1px #228b2231;
        }
      }

      .places {
        &-item {
          padding: 1.5rem;
          width: 100%;
          box-shadow: 0 0 0 0.5px black;
          box-sizing: border-box;
          margin-bottom: 2rem;
          transition: 0.2s;
          display: flex;

          &.focus {
            background-color: aliceblue;
            box-shadow: 0 0 0 2px #0289ff52, 0 0 4px 1px #0289ff31;
          }

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          &-left {
            flex-grow: 1;

            /deep/ .el-form-item__content {
              margin-left: 0 !important;
            }

            .radios {
              display: flex;
              justify-content: space-between;
              margin-bottom: 1.5rem;

              .el-radio {
                // background-color: white;
                margin: 0;
                margin-left: 1rem;
                flex-grow: 1;
                &:first-child {
                  margin-left: 0;
                }
              }
              .el-radio.is-bordered {
                border: 0;
              }
              /deep/ .el-radio__input.is-checked + .el-radio__label {
                color: #606266;
              }
            }
          }

          &-right {
            width: 3rem;
            line-height: 100%;
            text-align: right;
            position: relative;

            i {
              color: #999;
              cursor: pointer;
              position: absolute;
              top: 50%;
              transform: translate(-90%, -80%);
              transition: 0.3s;

              &:hover {
                color: red;
              }
            }
          }

          /deep/ .el-form-item {
            margin-bottom: 0.5rem;

            .el-input__inner {
              padding: 0 4px;
            }

            .el-form-item__error {
              margin: 1px 0 0 4px;
            }
          }
        }
      }
    }

    .right {
      width: 78%;
      box-sizing: border-box;
      position: relative;

      #mapCtx {
        width: 100%;
        height: 100%;
      }
      /deep/ .markerLabel {
        padding: 1rem 1.5rem;
        justify-content: center;
        align-items: center;
        border-radius: 4px;
        font-size: 1.5rem;
        color: #ffffff;
        box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.3);

        &.start {
          background-color: #0289ffbb;
        }

        &.startFC {
          background-color: #0289ff;
        }

        &.end {
          background-color: #228b22bb;
        }

        &.endFC {
          background-color: #228b22;
        }
      }
    }
  }

  .feeContent {
    height: calc(100% - 5rem);
    width: 60%;
    margin: 0 auto;

    h2 {
      margin: 5rem 0;
      width: 100%;
      text-align: center;
    }

    .tips {
      color: #999;
    }

    .el-form-item {
      margin: 0;
    }
  }

  .is-error {
    .el-input__inner {
      border: 1px #ff8252 solid;
    }

    .el-form-item__error {
      color: #ff8252;
    }
  }

  .buttons {
    height: 3rem;
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    div {
      width: 100%;
      line-height: 3rem;
      text-align: center;
      border: 1px black solid;
      border-radius: 3px;
      cursor: pointer;
      box-sizing: border-box;

      &:hover {
        border-width: 2px;
      }
    }

    &.mapButtons {
      width: 60%;
      padding: 0.8rem;
      border-radius: 4px;
      margin: 0;
      background-color: white;
      position: absolute;
      top: 10px;
      right: 10px;
      z-index: 2;

      // box-shadow: 0 0 10px 5px white;
      & > div {
        margin: 0 5px;
        cursor: pointer;
        width: 30%;
        &.active {
          border-color: #0289ff;
          color: #0289ff;
          background: #e8f4ff;
        }
      }

      /deep/ div:nth-child(1) {
        border: none;

        #chooseAddress,
        .area-input {
          width: 100% !important;
        }

        .close-btn {
          top: 0 !important;
        }

        .map-show {
          min-width: 350px;
          max-width: 50%;
          top: 135%;
          left: -20px;
          padding: 1rem 2rem 2rem;

          // box-shadow: 0 0 10px 5px white;
          .icon {
            background: url("../../../../assets/img/markerBegin.png") no-repeat;
            font-size: 0;
            position: relative;
            top: 5px;
          }

          .val {
            text-align: left;
          }
        }
      }
    }
  }

  .search {
    display: flex;
    justify-content: space-between;
    margin: 2rem 0 1rem;

    .el-input {
      width: 80%;
    }
  }

  .section-tip {
    font-size: 12px;
    color: #909399;
    background: #f0f9ff;
    border-left: 3px solid #0289ff;
    padding: 6px 10px;
    margin-bottom: 10px;
    line-height: 1.6;
    .el-button--text { font-size: 12px; padding: 0; }
  }

  .fence-status {
    font-size: 12px;
    color: #606266;
    padding: 4px 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 4px;
    &--warn { color: #E6A23C; }
  }

  .buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 0 0.5rem 1rem;

    .el-input {
      width: 80%;
    }
  }
}
</style>
